import { Store } from '@ngrx/store';
import { Component, OnInit, Pipe } from '@angular/core';
import { FaqActions, FaqSelectors } from 'src/app/store';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
    today: number = Date.now();
    vm$ = this.store.select(FaqSelectors.selectFaqVM);
    searchValue: string = '';

    constructor(private store: Store) {}

    ngOnInit() {
        this.store.dispatch(FaqActions.loadFaqStores());
    }

    filter(searchValue: string) {
        this.searchValue = searchValue.trim();
        this.store.dispatch(FaqActions.setFilterValue({ data: searchValue }));
    }
}

// pipe to highlight search text
@Pipe({
    name: 'highlight',
})
export class HighlightPipe {
    transform(value: string, args: string): any {
        if (!args) {
            return value;
        }
        // Create a regular expression to match the search term (args) in a case-insensitive manner
        const re = new RegExp(args, 'gi');

        // Replace the search term outside of <a> tags with the highlighting
        const replacedValue = value.replace(/(<a[^>]*>.*?<\/a>)|([^<]*?)(?=<|$)/gi, (match, linkTag, nonLinkText) => {
            if (linkTag) {
                // If it's inside an <a> tag, return it as is
                return linkTag;
            } else {
                // If it's outside an <a> tag, replace the search term with highlighting
                return nonLinkText.replace(re, '<span class="search-highlight">$&</span>');
            }
        });

        return replacedValue;
    }
}
